
import { defineComponent } from 'vue'
import ActiveUserMixin from '~/mixins/activeUserMixin'

import { AppFeatures } from '~/types/permTypes'
import { FeatureType } from '~/types/features'
import { canAccessFeature } from '~/utils/billing'

export default defineComponent({
  name: 'AddNewRepo',
  mixins: [ActiveUserMixin],
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    defaultActiveTab: {
      type: Number,
      default: 0
    },
    showMonorepo: {
      type: Boolean,
      default: true
    },
    analyzerShortcode: {
      type: String,
      default: ''
    },
    transformerShortcode: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      activeTabIndex: 0
    }
  },

  created() {
    this.activeTabIndex = this.defaultActiveTab
  },

  async fetch() {
    if (this.showMonorepo) {
      if (!this.activeOwner || !this.activeProvider) {
        await this.fetchActiveUserIfLoggedIn()
      }

      if (this.activeTabIndex >= this.tabItemList.length) {
        this.activeTabIndex = 0
      }
    }
  },

  watch: {
    '$route.path': {
      handler() {
        this.closeModal()
      }
    },
    refetchKeyForRouteChange: {
      handler() {
        this.refetchDataOnChange()
      }
    }
  },

  computed: {
    tabItemList() {
      const tabsConfig = [
        {
          title: 'Activate a repository',
          visible: true,
          component: 'ActivateSingleRepo',
          bindings: {
            'analyzer-shortcode': this.analyzerShortcode,
            'transformer-shortcode': this.transformerShortcode
          }
        },
        {
          title: 'Monorepos',
          visible: this.showMonorepoSection && this.showMonorepo,
          component: 'ActivateSingleRepo',
          bindings: {
            'analyzer-shortcode': this.analyzerShortcode,
            'list-monorepos-only': true,
            'transformer-shortcode': this.transformerShortcode
          }
        }
      ]

      return tabsConfig.filter((item) => item.visible)
    },

    activeTabItem() {
      return this.tabItemList[this.activeTabIndex] ?? this.tabItemList[0]
    },

    showMonorepoSection() {
      const hasFeatureAccess = this.$config.onPrem ||
        canAccessFeature(FeatureType.MONOREPOS, this.activeDashboardContext?.subscribed_plan_info)
      return hasFeatureAccess && this.$gateKeeper.provider(AppFeatures.MONOREPO, this.activeProvider)
    },

    refetchKeyForRouteChange() {
      return `${this.activeProvider}-${this.activeOwner}`
    }
  },

  methods: {
    updateActiveIndex(index: number) {
      if (index < this.tabItemList.length) {
        this.activeTabIndex = index
      }
    },

    closeModal() {
      this.$emit('close')
    },

    refetchDataOnChange() {
      this.$fetch()
    }
  }
})
